<template>
    <div>
        <div id="header-container" class="px-5 in-step">
            <img :src="`${publicPath}/img/gep/bg-header.svg`" class="img-header">
            <div class="pt-4 text-white mb-4">
                <h3 class="text-white">{{ $t('Remittance') }}</h3>
                <span class="fz-16 fw-400">Fill out the form to resubmit remittance</span>
            </div>

            <step-container
                :current_step="3"
                :step_list="stepList"
            ></step-container>
        </div>

        <b-container fluid class="pb-5">
            <div id="body-container" class="px-4 pt-3">
                <b-row>
                    <b-col cols="12">
                        <h5 class="mb-4">{{ $t('Withdrawal') }}</h5>
                    </b-col>
                </b-row>
                <b-row>

                    <b-col cols="12" md="6">
                        <div class="form-group mb-3">
                            <label>{{ $t('Payment Methods') }}</label>
                            <input type="text" readonly class="form-control-plaintext px-2" id="paymentMode" :value="params.paymentMode">
                            <div v-if="error['paymentMode']" class="invalid-feedback d-block mb-3">
                                {{$t(error['paymentMode'])}}
                            </div>
                        </div>
                    </b-col>

                    <b-col cols="12" md="6">
                        <div class="form-group mb-3">
                            <label>{{ $t('Select Currency') }} <span class="text-danger">*</span></label>
                            <select class="form-control" @change="onChangeUserCurrency" v-model="params.senderCurrency">
                                <option value=""></option>
                                <optionUserCurrency
                                v-if="user_currency.length>0"
                                v-for="item in user_currency"
                                :currency = "item"
                                :mapping_currency = "mapping_currency"
                                :userNo = "userNo"
                                :key="item"
                                >
                                </optionUserCurrency>
                            </select>
                            <div v-if="error.senderCurrency" class="invalid-feedback d-block">
                                {{$t(error.senderCurrency)}}
                            </div>
                        </div>
                    </b-col>

                    <b-col cols="12" md="6">
                        <div class="form-group mb-3">
                            <label>{{ $t('Amount') }} <span class="text-danger">*</span></label>
                            <MaskAmount @set-price="changePrice($event)" :bus="withdrawal" ref="withdrawalAmount"></MaskAmount>
                            <div v-if="error.amount" class="invalid-feedback d-block">
                                {{$t(error.amount)}}
                            </div>
                        </div>
                    </b-col>
                   
                    <b-col cols="12" md="6">
                        <div class="d-flex align-items-end mb-3">
                            <div class="form-group w-100 mb-0 mr-2">
                                <label>{{ $t('Payment Type') }} <span class="text-danger">*</span></label>
                                <Select2 v-model="params.fixedModel" :options="fixedModelList" @select="onSelectFixedModel($event)" :settings='{ escapeMarkup: doEscapeMarkup,placeholder:$t("Payment Type")}' class="form-control"/>
                                <div v-if="error['fixedModel']" class="invalid-feedback d-block mb-3">
                                    {{$t(error['fixedModel'])}}
                                </div>
                            </div>
                        </div>
                    </b-col>
                    <b-col cols="12" md="6">
                        <div class="form-group mb-3">
                            <label>{{ $t('Purpose of Payment') }} <span class="text-danger">*</span></label>
                            <Select2 v-model="params.paymentPurpose" :options="paymentPurposeOpt" @select="onSelectPurpose($event)" :settings='{ escapeMarkup: doEscapeMarkup,placeholder:$t("Select purpose")}' class="form-control"/>
                            <div v-if="error['paymentPurpose']" class="invalid-feedback d-block mb-3">
                                {{$t(error['paymentPurpose'])}}
                            </div>
                        </div>
                    </b-col>     
                    
                    <b-col cols="12" md="6">
                        <div class="form-group mb-3">
                            <label>{{ $t('Select Fee Currency') }} <span class="text-danger">*</span></label>
                            <select class="form-control" @change="onChangepaymentFeeCcy" v-model="params.paymentFeeCcy">
                                <option value=""></option>
                                <optionUserCurrency
                                v-if="user_currency.length>0"
                                v-for="item in user_currency"
                                :currency = "item"
                                :notzero = true
                                :hidebalance = true
                                :defaultCcy = "params.paymentFeeCcy"
                                :mapping_currency = "mapping_currency"
                                :userNo = "userNo"
                                :key="item"
                                >
                                </optionUserCurrency>
                            </select>
                            <div v-if="error.paymentFeeCcy" class="invalid-feedback d-block">
                                {{$t(error.paymentFeeCcy)}}
                            </div>
                        </div>
                    </b-col>

                    <b-col cols="12" md="6">
                        <div class="form-group mb-3">
                            <label>{{ $t('Bank charges to be borne') }} <span class="text-danger">*</span></label>
                            <Select2 v-model="params.costBorne" :options="costBorneOpt" @select="onSelectCostBorne($event)" :settings='{ escapeMarkup: doEscapeMarkup,placeholder:$t("Bank charges to be borne")}' class="form-control"/>
                            <div v-if="error['costBorne']" class="invalid-feedback d-block mb-3">
                                {{$t(error['costBorne'])}}
                            </div>
                        </div>
                    </b-col>

                    <b-col cols="12" md="6">
                        <div class="form-group mb-3">
                            <div class="d-flex align-items-center">
                                <label for="paymentFee" class="mb-0 text-nowrap">{{ $t('Payment Fee') }}</label>
                                <input type="text" readonly class="form-control-plaintext text-danger px-2" id="paymentFee" :value="this.params.paymentFee?this.params.paymentFee+' USD':'-'">
                            </div>
                            <div v-if="error['paymentFee']" class="invalid-feedback d-block mb-3">
                                {{$t(error['paymentFee'])}}
                            </div>
                        </div>
                    </b-col>

                    <b-col cols="12" md="6">
                        <div class="form-group mb-3">
                            <label>{{ $t('Proof of Payment') }} <span class="text-danger">*</span></label>
                            <FileUploader  
                                ref="fileUploader"
                                :type="'browse'"
                                :allowed_types = "['pdf','doc', 'docx', 'rar', 'zip']"
                                :size="20*1024*1024"
                                @capture-file="captureFile($event)" 
                                @remove-image="removeImage($event)">
                            </FileUploader>
                            <div v-if="error['paymentMaterial']" class="invalid-feedback d-block mb-3">
                                {{$t(error['paymentMaterial'])}}
                            </div>
                        </div>
                    </b-col>

                    <b-col cols="12" md="6">
                        <div class="form-group mb-3">
                            <label>{{ $t('Remarks') }}</label>
                            <input type="text" v-model="params.paymentReference" class="form-control" :placeholder="$t('Payment Reference')"/>
                            <div v-if="error['paymentReference']" class="invalid-feedback d-block mb-3">
                                {{$t(error['paymentReference'])}}
                            </div>
                        </div>
                    </b-col>
                    
                </b-row>
                <b-row class="mb-5">
                    <b-col cols="12" class="d-flex">
                        <button @click="$router.go(-1);" class="btn btn-previous d-block mr-auto">{{ $t('Previous') }}</button>
                        <button @click="doSubmit" class="btn btn-primary d-block">{{ $t('Next') }}</button>
                    </b-col>
                </b-row>
                
            </div>
        </b-container>

        <LoaderComponent v-if="isLoading"></LoaderComponent>
    </div>
</template>
<script>

import LoaderComponent from "@/components/LoaderComponent";
import Select2 from 'v-select2-component';
import CreateAccount from "@/services/CreateAccount";
import Withdrawal from "@/services/Withdrawal";
import DB from "@/services/DB";
import MaskAmount from "@/components/Mask/MaskAmount";
import optionUserCurrency from '@/components/optionUserCurrency';
import stepContainer from "@/components/CardManagement/stepContainer";
import FileUploader from '@/components/Kyc/FileUploader.vue';
import { EventBus } from '@/services/eventBus';

import Vue from "vue";

const FIXED_MODEL = {
                1:"Foreign Exchange Account",
                2:"Receiving Account"
            };

const PAYMENT_PURPOSE = {
                1:"current settlement",
                2:"loan",
                3:"travel expenses",
                4:"living expenses",
                5:"investment funds",
                6:"office expenses",
                7:"engineering funds",
                8:"labor costs/salaries",
                9:"tuition fees",
                10:"others"
            };

const COST_BORNE = {
                "OUR":"OUR (sender pays all charges)",
                "SHA":"SHA (shared charges)"
            };

const PAYMENT_CHANNEL = {
    "SWIFT":"SWIFT",
    "LOCAL":"LOCAL"
}

const FEE = {
    "SWIFT":{
        "SHA":25,
        "OUR":55
    },
    "LOCAL":{
        "AUS":4,
        "JPN":10,
        "IDN":4,
        "CAN":7,
        "FIN":4,
        "FRA":4,
        "DEU":4,
        "SGP":4,
        "ESP":4,
        "SWE":4,
        "SWZ":4,
        "GBR":4,
        "MYS":4,
        "VNM":4,
        "USA":4,
        "THA":4,
        "PHL":4,
        "HKG":5,
        "PRK":5,
        "KOR":5,
        "CRI":10,
        "ECU":10,
        "LKA":10,
        "IND":30,
        "NZL":7,
        "POL":4,
        "LUX":4,
        "KHM":10
    }
}

export default {
   name: 'update-remittance',
   data() {
       return {
            publicPath :process.env.BASE_URL!='/'?process.env.BASE_URL:'',
            user_currency:[],
            benificiaryList:[],
            stepList:["Update Partner Info", "Update Bank Info", "Update Remittance", "Summary"],
            userNo:'',
            accountId:'',
            isLoading:false,
            withdrawal:new Vue(),
            selectedAccountName:'',
            selectedCardNo:'',
            payeeCcy:'',
            paymentChannelTypeOpt:[],
            fixedModelList:[],
            paymentPurposeOpt:[],
            costBorneOpt:[],
            mappingFee:FEE,
            optional:['paymentReference'],
            params:{
                partnerBankId:'',
                paymentMode:'',
                senderCurrency:'',
                paymentFee:'',
                paymentFeeCcy:'',
                amount:'',
                fixedModel:'',
                paymentPurpose:'',
                paymentReference:'',
                costBorne:'',
                paymentMaterial:''
            },
            error:{
                partnerBankId:'',
                paymentMode:'',
                senderCurrency:'',
                paymentFee:'',
                paymentFeeCcy:'',
                amount:'',
                fixedModel:'',
                paymentPurpose:'',
                paymentReference:'',
                costBorne:'',
                paymentMaterial:'',
            }
       }
   },
   components: {
       LoaderComponent,
       Select2,
       optionUserCurrency,
       MaskAmount,
       stepContainer,
       FileUploader
   },
   methods:{
    setFee(){
        this.params.paymentFee = '';
        if(this.params.paymentMode == 'SWIFT' && this.params.costBorne){
            this.error.paymentFee = '';
            this.params.paymentFee = this.mappingFee[this.params.paymentMode][this.params.costBorne];
        }
        else if(this.params.paymentMode == 'LOCAL' && this.payeeCountry){
            this.error.paymentFee = '';
            const fee = this.mappingFee[this.params.paymentMode][this.payeeCountry];
            this.params.paymentFee = fee?fee:4;
        }
    },
    onChange(key){
        if(key=='paymentMode'){
            this.setFee();
        }
        this.error[key]="";
    },
    captureFile($event) {
        this.error.paymentMaterial="";
        this.params.paymentMaterial=$event;
    },
    removeImage($event){
        this.params.paymentMaterial="";
        this.error.paymentMaterial="";
    },
    gotoAddBeneficiary(){
        localStorage.removeItem('add_partner');
        localStorage.removeItem('bank_info');

        this.$router.push({ 
            path: '/add-partner', 
        });
    },
    onSelectCostBorne(){
        this.setFee();
        this.error.costBorne = '';
    },
    onSelectPurpose(){
        this.error.paymentPurpose = '';
    },
    onSelectFixedModel(){
        this.error.fixedModel = '';
    },
    onChangeUserCurrency(){
        this.error.senderCurrency='';
    },
    changePrice(event){
        this.error.amount = '';
        this.params.amount = event;
    },
    doEscapeMarkup(markup){
        return markup;
    },
    getUser(){
        let self = this;
        CreateAccount.list().then((response)=>{
            if (response.status == 200) {
                let account = response.data.data;
                if(account){
                    account.forEach(element => {
                        if(element.status == 2){
                            self.accountId = element.id;
                            self.userNo = element.userNo;
                            self.getContact();
                            self.getSubAccount();
                        }
                    });
                }
            }
        });
    },
    getSubAccount(){
        let self = this;
        CreateAccount.listSubAccount({
                start:0,
                length:-1,
                search:{value:self.userNo}
            }).then((response)=>{
                if (response.status == 200) {
                    if(response.data.data.length>0){
                        self.sub_account = response.data.data[0];
                        self.user_currency = this.sub_account['currency'].split(",");
                    }
                }
            });
    },
    getContact(){
        let self = this;
        var opt = {
            userNo              : this.userNo,
            page  				: this.currentPage,
            pagesize 			: -1,
            sort				: "-updated_at"
        };

        Withdrawal.partnerList(opt).then((response)=>{
            if (response.status == 200) {
                let data = response.data;
                data.forEach(function(item,index){
                    if(self.params.partnerBankId == item.id){
                        self.selectedAccountName = item.accountName;
                        self.selectedCardNo = item.cardNo;
                        self.payeeCcy = item.accountCcy;
                    }
                    self.benificiaryList.push({"text":item.accountName+" - "+item.cardNo,"id":item.id,"name":item.accountName,"cardNo":item.cardNo,"accountCcy":item.accountCcy});
                });
            }
        });
    },
    onChangepaymentFeeCcy(){
        this.error.paymentFeeCcy = '';
    },
    validate(){
        let success = true;
        let self = this;
        Object.keys(this.params).forEach(function(key) {
            if(!self.params[key]&& !self.optional.includes(key)){
                self.error[key]="can not be blank.";
                success = false;
            }
        });
        console.log(this.params);
        return success;
    },
    doSubmit(){
        let self = this;
        if(this.validate()){
            let payeeAmount = this.params.amount;
            let paymentAmount = this.params.amount;

            if(this.params.fixedModel == 1){
                payeeAmount = 0;
            }
            else{
                paymentAmount = 0;
            }

            const remittanceValue = {
                partnerBankId:this.params.partnerBankId,
                paymentMode:this.params.paymentMode,
                paymentCcy:this.params.senderCurrency,
                paymentAmount:paymentAmount,
                payeeAmount:payeeAmount,
                payeeCcy:this.payeeCcy,
                fixedModel:parseInt(this.params.fixedModel),
                paymentPurpose:parseInt(this.params.paymentPurpose),
                paymentReference:this.params.paymentReference,
                costBorne:this.params.costBorne,
                paymentFeeCcy:this.params.paymentFeeCcy,
                paymentFee:this.params.paymentFee,
                cardNo:this.selectedCardNo,
                accountName:this.selectedAccountName,
                userNo:this.userNo,
                accountId:this.accountId
            };
            
            if(this.$refs['fileUploader'].image.indexOf("http://")!=-1 || this.$refs['fileUploader'].image.indexOf("https://")!=-1){
                remittanceValue.paymentMaterial = this.params.paymentMaterial;
            }

            DB.save('paymentMaterial_filetype_update',this.$refs['fileUploader'].extension).then(message => {
                DB.save('paymentMaterial_update', this.$refs['fileUploader'].image).then(message => {
                    localStorage.setItem('update_remittance', JSON.stringify(remittanceValue));
                
                    this.$router.push({ 
                        path: 'resubmit-remittance-summary',
                        query: { "id":self.$route.query['id'] }
                    });
                });
            });
        }
    },
    getMessage: function (key) {
        return this.$t(key)
    },
    checkError(err){
        this.isLoading = false;
        const response = err.response;  
        console.log("===================");
        let self = this;
        if(response.status == 400){
            console.log(response.data);
            if(typeof response.data.message === 'string'){
                this.$swal({
                    icon: 'info',
                    html:response.data.message,
                    showConfirmButton: true,
                    confirmButtonText: self.getMessage('OK')
                });
            }
            else{
                if(response.data.message['errorMsg']){
                    this.$swal({
                        icon: 'info',
                        html:response.data.message['errorMsg'],
                        showConfirmButton: true,
                        confirmButtonText: self.getMessage('OK')
                    });
                }
                else{
                    let ret = [];
                    Object.keys(response.data.message).forEach((key) => {
                        ret.push(response.data.message[key][0]);
                    });

                    this.$swal({
                        icon: 'info',
                        html:ret.join("<br>"),
                        showConfirmButton: true,
                        confirmButtonText: self.getMessage('OK')
                    });
                }
            }
        }      
        else if(response.status == 401 && response.data.name == "Unauthorized"){
                localStorage.removeItem("token");
                localStorage.removeItem("member");
                localStorage.removeItem("isFirstTime");
                this.$router.push({ 
                    path: '/login', 
                });
        }
        else{
            if(localStorage.getItem("token")){
                var msg = (response.data)?response.data.message:err.message;
                this.$notify({
                    type: 'warn',
                    text: msg
                })
            }
        }
    }
   },
   mounted(){
    let self = this;
        this.$nextTick(() => {

            this.paymentChannelTypeOpt = [];
            Object.keys(PAYMENT_CHANNEL).forEach(key => {
                this.paymentChannelTypeOpt.push({"id":key,"text":PAYMENT_CHANNEL[key]});
            });

            this.fixedModelList = [];
            Object.keys(FIXED_MODEL).forEach(key => {
                this.fixedModelList.push({"id":key,"text":FIXED_MODEL[key]});
            });

            this.paymentPurposeOpt = [];
            Object.keys(PAYMENT_PURPOSE).forEach(key => {
                this.paymentPurposeOpt.push({"id":key,"text":PAYMENT_PURPOSE[key]});
            });

            this.costBorneOpt = [];
            Object.keys(COST_BORNE).forEach(key => {
                this.costBorneOpt.push({"id":key,"text":COST_BORNE[key]});
            });

            CreateAccount.listCurrency().then((response)=>{
                self.mapping_currency = response.data;
                self.getUser();
                
                DB.get("paymentMaterial_update").then(item => {
                    if(item){
                        self.$refs["fileUploader"].image = item;
                        self.params.paymentMaterial = item;
                    }
                });
                
                let remittance = localStorage.getItem("remittance");
                if(remittance){
                    remittance = JSON.parse(remittance);
                    Object.keys(this.params).forEach(key => {
                        if(this.params[key]==''){
                            this.params[key] = remittance[key];
                        }
                    });

                    this.params.amount = (this.params.fixedModel == 1)?remittance["paymentAmount"]:remittance["payeeAmount"];
                    this.$refs["withdrawalAmount"].init(this.params.amount);
                    
                    this.params.senderCurrency = remittance.paymentCcy;
                }
                else if(this.$route.query['id']){
                    Withdrawal.remittanceList({id:this.$route.query['id']}).then((response)=>{
                        let data = response.data;
                        if(data.length>0){
                            data = data[0];
                            Object.keys(self.params).forEach(key => {
                                if(!self.params[key] && data[key]){
                                    self.params[key] = data[key];
                                }
                            });

                            this.params.amount = (this.params.fixedModel == 1)?data["paymentAmount"]:data["payeeAmount"];
                            this.$refs["withdrawalAmount"].init(this.params.amount);
                            self.$refs["fileUploader"].image = data['paymentMaterialFile']['file'];
                            this.params.senderCurrency = data.paymentCcy;
                        }
                    });
                }

                let update_bank_info = localStorage.getItem("update_bank_info");
                if(update_bank_info){
                    update_bank_info = JSON.parse(update_bank_info);
                    this.params.paymentMode=update_bank_info['paymentChannelType'];
                }
                
            });
        });
   }
};
</script>

<style>
input#paymentFee,
input#paymentMode{
    border: unset !important;
}
</style>
